export function Logo({ size = 36, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Logo Copiveo"
      >
        <defs>
          <linearGradient id="cg" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#1769E0" />
            <stop offset="100%" stopColor="#0F3D91" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="url(#cg)" />
        <path
          d="M18 40 L28 50 L48 24"
          stroke="#F28C28"
          strokeWidth="7"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      {withText && (
        <div className="leading-tight">
          <div className="font-heading font-bold text-xl text-foreground tracking-tight">
            Copiveo
          </div>
          <div className="text-[10px] uppercase tracking-[0.15em] text-muted-foreground -mt-0.5">
            by EducForm31
          </div>
        </div>
      )}
    </div>
  );
}
